import React, { useState, useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';

import 'moment/locale/pl';
import {
  getSpecificCategoryRequest,
  updateCategoryRequest,
} from '../requests/fertilizersRequests';

const FertilizersCategoriesEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);

  useEffect(() => {
    toggleLoading(true);
    getSpecificCategoryRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['title'],
              value: data.name,
            },
            {
              name: ['subCatName'],
              value: data.subCatName,
            },
            {
              name: ['color'],
              value: data.color,
            },
            {
              name: ['sortOrder'],
              value: data.sortOrder,
            },
            {
              name: ['isActive'],
              value: data.isActive || false,
            },
          ]);
          if (data.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/news-categories');
        }
      })
      .catch(() => {
        history.push('/news-categories');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    updateCategoryRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Ustawienia treści</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilizers/categories">Nawozy</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/fertilizers/categories/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="title"
                label="Kategoria główna nawozów"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="subCatName"
                label="Podkategoria nawozów"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="color"
                label="Kolor nawozów RGB"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="sortOrder"
                label="Kolejność"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        if (
                          (value.length > 5 ||
                            !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                          value.length > 0
                        ) {
                          return Promise.reject(
                            new Error('Proszę podać poprawną wartość!')
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{
                    width: '100px',
                  }}
                />
              </Form.Item>
              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/fertilizers/categories">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/fertilizers/categories">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default FertilizersCategoriesEdit;
